module.exports = __webpack_public_path__ + "static/media/sky-terrace-5.787d0771.jpg";